import React, { Component } from 'react';
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import SkinSavePopup from "./SkinSavePopup";
import ErrorToastPopup from "../../common/ErrorToastPopup";
import LoadingPopup from "../../common/LoadingPopup";
import SkinDetailPopup from "./SkinDetailPopup";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {closePopup, hideLoadingPopup, showErrorToastPopup, showLoadingPopup, showSkinSavePopup} from "../../../actions/popup";
import {isDescendant} from "../../../utils/DomHelper";
import WindowEventHelper from "../../../lib/WindowEventHelper";
import {addPrefix} from "../../../utils/UriUtil";
import {CONFIRM_CHANGE_SKIN_MSG} from "./SkinMsg";

@connect(state => ({
    isPopupOpened: (typeof state.popup !== 'undefined' && state.popup.isSkinDetailPopupOpened)
    || (typeof state.popup !== 'undefined' && state.popup.isSkinSavePopupOpened)
    || (typeof state.popup !== 'undefined' && state.popup.isErrorToastPopupOpened)
    || (typeof state.popup !== 'undefined' && state.popup.isLoadingPopupOpened),

    isSkinDetailPopupOpened : state.popup.isSkinDetailPopupOpened,
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
    handleShowSkinAddPopup: (title, description, callBack) => {
        dispatch(showSkinSavePopup(title, description, callBack))
    },
    handleHideLoadingPopup: () => {
        dispatch(hideLoadingPopup())
    },
    handleShowLoadingPopup: (loadingPopupMessage) => {
        dispatch(showLoadingPopup(loadingPopupMessage))
    },
    handleShowErrorToastPopup: (title, description) => {
        dispatch(showErrorToastPopup(title, description))
    },
    dispatch
}))
class SkinPopupLayer extends Component {
    componentWillUnmount() {
        document.body.className = "";
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isPopupOpened) {
        	WindowEventHelper.add("keydown", this.handleKeyDown)
            document.body.className = "scroll_hide";
        }
        else {
			WindowEventHelper.remove("keydown", this.handleKeyDown)
            document.body.className = "";
        }
    }


    @autobind
    handleSetSkin(skinName) {

      if(!confirm(CONFIRM_CHANGE_SKIN_MSG))
        return false;


        const { dispatch } = this.props;

        this.props.handleShowLoadingPopup('적용 중입니다.');
        let formdata = new FormData()
        formdata.append("name", skinName)
        fetch(addPrefix("/manage/design/skin/set.json"), {
            credentials: 'include',
            method: 'post',
            body: formdata
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleHideLoadingPopup();
                this.props.refetch();
                window.scrollTo(0, 0)
            })
            .catch(e => {
                console.error(e)
                this.props.handleHideLoadingPopup();
                // this.props.handleShowErrorToastPopup('스킨 적용에 실패했습니다.', '다시 시도해 주세요.')
            });
    }

    @autobind
    handleKeyDown(e) {
        const keyCode = e.keyCode;
        const tagName = e.target.tagName;
        if (keyCode == 27) {
            this.props.handlePopupClose();
        }
    }

    @autobind
    handleClose(e) {
        const { layer } = this.refs
        if (!isDescendant(layer, e.target)) {
            this.props.handlePopupClose();
        }
    }

    render() {
        const divStyle = {position: 'fixed', display: this.props.isPopupOpened?'block':'none'};
        const { isSkinDetailPopupOpened } = this.props;
        return (
            <div ref="layer" className="container_layer" style={divStyle} onClick={this.handleClose}>
                <SkinSavePopup/>
                <SkinDetailPopup setSkin={this.handleSetSkin} />
                <ErrorToastPopup/>
                <LoadingPopup/>
                { isSkinDetailPopupOpened && <label className="lab_btn lab_close">
                    <span className="ico_blog">레이어 닫기</span>
                    <input type="button" className="btn_g" value="닫기" onClick={this.props.handlePopupClose}/>
                </label>}
            </div>
        );
    }
}

export default SkinPopupLayer
